<template lang="">
  <Layout>
    <template v-if="this.$route.name == 'add-payment-type'">
      <PageHeader :title="title1" :items="items"></PageHeader>
    </template>
    <template v-else>
      <PageHeader :title="title2" :items="items"></PageHeader>
    </template>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-form enctype="multipart/form-data" ref="email" class="row">
              <b-form-group
                id="input-group-1"
                label-for="input-1"
                class="col-12"
              >
                <label style="font-weight: 500"
                  >Name <span style="color: red">*</span></label
                >
                <b-form-input
                  id="input-1"
                  placeholder="Enter Name"
                  v-model="form.name"
                  :class="{
                    'is-invalid': submitted && $v.form.name.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.form.name.required"
                  class="invalid-feedback"
                >
                  name is required.
                </div>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label-for="input-1"
                class="col-12"
              >
                <b-form-checkbox @input="changestatus" v-model="form.status"
                  >is active</b-form-checkbox
                >
              </b-form-group>

              <div class="col-12">
                <b-button
                  type="submit"
                  variant="primary"
                  class="mr-2"
                  @click.prevent="submitData"
                  ><span v-if="this.$route.name == 'add-payment-type'"
                    >Save Data</span
                  >
                  <span v-else>Update Data</span>
                </b-button>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import MixinRequest from "../../../../mixins/request";
import gatwayTypeMixin from "../../../../mixins/ModuleJs/payment-gateway-type";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [MixinRequest, gatwayTypeMixin],
  data() {
    return {
      title1: "ADD PAYMENT GATEWAYS TYPE",
      title2: "EDIT PAYMENT GATEWAY TYPE",
      items: [
        {
          text: "Back",
          href: "/payment-type",
        },
        {
          text: "Data",
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
  validations: {
    form: {
      name: { required },
    },
  },
};
</script>
